import React from 'react';
import useUsers from 'state/users';
import { dateFormat } from 'utils/date';
import { getFullName } from 'utils/text';
import ResponsiveText from 'components/Table/responsive/Text';

const getUserName = (users, i) => {
  const user = users.find(({id})=>id===i);
  return user ? getFullName(user) : ''; 
}

const WhoWhen = ({ item }) => {
  const [users] = useUsers();

  return (
    <div style={{padding: '0 5px'}}>
      <ResponsiveText text={getUserName(users.all, item.who86)} />
      <div style={{height: '10px'}}></div>
      <ResponsiveText text={dateFormat(item.when86)} />
    </div>
  );
};

export default WhoWhen;
